import { JaaSMeeting } from '@jitsi/react-sdk';
///import { JaaSMeeting, JitsiMeeting } from '@jitsi/react-sdk';
import React from 'react';
import {MetaTags} from 'react-meta-tags';
import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
///import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      left: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const App = () => {
    var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
    const authResult = new URLSearchParams(window.location.search); 
	const meetingId = authResult.get('meetingId');
    const meetingTitle = authResult.get('meetingTitle');
    
    if(!meetingId){
        window.location.href='dashboard';
    }

    // const apiRef = useRef();
    // const [ logItems, updateLog ] = useState([]);
    // const [ showNew, toggleShowNew ] = useState(false);
    // const [ knockingParticipants, updateKnockingParticipants ] = useState([]);

    // const printEventOutput = payload => {
    //     updateLog(items => [ ...items, JSON.stringify(payload) ]);
    // };

    // const handleAudioStatusChange = (payload, feature) => {
    //     if (payload.muted) {
    //         updateLog(items => [ ...items, `${feature} off` ])
    //     } else {
    //         updateLog(items => [ ...items, `${feature} on` ])
    //     }
    // };

    // const handleChatUpdates = payload => {
    //     if (payload.isOpen || !payload.unreadCount) {
    //         return;
    //     }
    //     apiRef.current.executeCommand('toggleChat');
    //     updateLog(items => [ ...items, `you have ${payload.unreadCount} unread messages` ])
    // };

    // const handleKnockingParticipant = payload => {
    //     updateLog(items => [ ...items, JSON.stringify(payload) ]);
    //     updateKnockingParticipants(participants => [ ...participants, payload?.participant ])
    // };

    // const resolveKnockingParticipants = condition => {
    //     knockingParticipants.forEach(participant => {
    //         apiRef.current.executeCommand('answerKnockingParticipant', participant?.id, condition(participant));
    //         updateKnockingParticipants(participants => participants.filter(item => item.id === participant.id));
    //     });
    // };

    // const handleJitsiIFrameRef1 = iframeRef => {
    //     iframeRef.style.border = '10px solid #3d3d3d';
    //     iframeRef.style.background = '#3d3d3d';
    //     iframeRef.style.height = '400px';
    //     iframeRef.style.marginBottom = '20px';
    // };

    // const handleJitsiIFrameRef2 = iframeRef => {
    //     iframeRef.style.marginTop = '10px';
    //     iframeRef.style.border = '10px dashed #df486f';
    //     iframeRef.style.padding = '5px';
    //     iframeRef.style.height = '400px';
    // };

    const handleJaaSIFrameRef = iframeRef => {
        iframeRef.style.border = '3px solid #3d3d3d';
        iframeRef.style.background = '#3d3d3d';
        iframeRef.style.height = '99vh';
    };

    // const handleApiReady = apiObj => {
    //     apiRef.current = apiObj;
    //     apiRef.current.on('knockingParticipant', handleKnockingParticipant);
    //     apiRef.current.on('audioMuteStatusChanged', payload => handleAudioStatusChange(payload, 'audio'));
    //     apiRef.current.on('videoMuteStatusChanged', payload => handleAudioStatusChange(payload, 'video'));
    //     apiRef.current.on('raiseHandUpdated', printEventOutput);
    //     apiRef.current.on('titleViewChanged', printEventOutput);
    //     apiRef.current.on('chatUpdated', handleChatUpdates);
    //     apiRef.current.on('knockingParticipant', handleKnockingParticipant);
    // };

    const handleReadyToClose = () => {
        /* eslint-disable-next-line no-alert */
        ///alert('Ready to close...');
        window.location.href='liveclass';
    };

    const DialogTitle = withStyles(styles)((props) => {
        const { children, classes, onClose, ...other } = props;
        return (
          <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
              <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                <ArrowBackIcon />
              </IconButton>
            ) : null}
          </MuiDialogTitle>
        );
      });

      const handleClose = () => {
        window.location.href='liveclass';
      };

    return (
        <div style={{overflow: 'hidden'}} >
              <MetaTags>
            		<title>Teacher Help</title>
          		</MetaTags>

            <DialogTitle title="Exit" style={{marginBottom:'-32px'}} onClose={handleClose}></DialogTitle>
            {/* <JitsiMeeting
				appId = { 'vpaas-magic-cookie-a56e8265804147f888b34d0127fb0faa' }
				jwt = { "eyJraWQiOiJ2cGFhcy1tYWdpYy1jb29raWUtYTU2ZTgyNjU4MDQxNDdmODg4YjM0ZDAxMjdmYjBmYWEvZDhkOWNiLVNBTVBMRV9BUFAiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiJqaXRzaSIsImlzcyI6ImNoYXQiLCJpYXQiOjE2OTI2MjQxMDIsImV4cCI6MTY5MjYzMTMwMiwibmJmIjoxNjkyNjI0MDk3LCJzdWIiOiJ2cGFhcy1tYWdpYy1jb29raWUtYTU2ZTgyNjU4MDQxNDdmODg4YjM0ZDAxMjdmYjBmYWEiLCJjb250ZXh0Ijp7ImZlYXR1cmVzIjp7ImxpdmVzdHJlYW1pbmciOnRydWUsIm91dGJvdW5kLWNhbGwiOnRydWUsInNpcC1vdXRib3VuZC1jYWxsIjpmYWxzZSwidHJhbnNjcmlwdGlvbiI6dHJ1ZSwicmVjb3JkaW5nIjp0cnVlfSwidXNlciI6eyJoaWRkZW4tZnJvbS1yZWNvcmRlciI6ZmFsc2UsIm1vZGVyYXRvciI6dHJ1ZSwibmFtZSI6Im5hdmVlbi5hdmFpbGFibGUiLCJpZCI6Imdvb2dsZS1vYXV0aDJ8MTA5Njg0MjgyODQxODAzNjMyNjExIiwiYXZhdGFyIjoiIiwiZW1haWwiOiJuYXZlZW4uYXZhaWxhYmxlQGdtYWlsLmNvbSJ9fSwicm9vbSI6IioifQ.SRt8dXHsSvOjM0imm1GLYDf0T09KFRnVoFGPeEwU9GUtmv0C4yUoHK4TJnj7hEh327-ngxEo1K70OEbeuoi_xbbvV19sIVc0UyOgFHO1nPfVG1c42nkXTV3Xqib4MFWKCOgFIQbM71IZppdkCAic7GZKGtgIgEbIb7h4e1BuoHh-31NCzhbloBGk5T3YfYs44559LewMRVCTYE2FD3NSWgfTwIkNsi0TjfV77sQrsnNC40SRQ1WxnusMziBloWLsX4t6bz8Cvk9ooowl19GmOEJAxItBa3KkcOTxwSi-Binp2XNkS3J4wtvnnOEryn1JmKumEzlUlq7vJm3yZWTe1A" }
                roomName = { generateRoomName() }
                spinner = { renderSpinner }
                // configOverwrite = {{
                //     subject: 'ETL Testing',
                //     hideConferenceSubject: false
                // }}
                onApiReady = { externalApi => handleApiReady(externalApi) }
                onReadyToClose = { handleReadyToClose }
                getIFrameRef = { handleJitsiIFrameRef1 } /> */}
            <JaaSMeeting
				appId = { 'vpaas-magic-cookie-aba79ddf8e1240208877b324a88ff4d1' }
				jwt = {etlStudentObj.jitsiToken}
                ///jwt = { "eyJraWQiOiJ2cGFhcy1tYWdpYy1jb29raWUtYTU2ZTgyNjU4MDQxNDdmODg4YjM0ZDAxMjdmYjBmYWEvZDhkOWNiLVNBTVBMRV9BUFAiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiJqaXRzaSIsImlzcyI6ImNoYXQiLCJpYXQiOjE2OTI2MjQxMDIsImV4cCI6MTY5MjYzMTMwMiwibmJmIjoxNjkyNjI0MDk3LCJzdWIiOiJ2cGFhcy1tYWdpYy1jb29raWUtYTU2ZTgyNjU4MDQxNDdmODg4YjM0ZDAxMjdmYjBmYWEiLCJjb250ZXh0Ijp7ImZlYXR1cmVzIjp7ImxpdmVzdHJlYW1pbmciOnRydWUsIm91dGJvdW5kLWNhbGwiOnRydWUsInNpcC1vdXRib3VuZC1jYWxsIjpmYWxzZSwidHJhbnNjcmlwdGlvbiI6dHJ1ZSwicmVjb3JkaW5nIjp0cnVlfSwidXNlciI6eyJoaWRkZW4tZnJvbS1yZWNvcmRlciI6ZmFsc2UsIm1vZGVyYXRvciI6dHJ1ZSwibmFtZSI6Im5hdmVlbi5hdmFpbGFibGUiLCJpZCI6Imdvb2dsZS1vYXV0aDJ8MTA5Njg0MjgyODQxODAzNjMyNjExIiwiYXZhdGFyIjoiIiwiZW1haWwiOiJuYXZlZW4uYXZhaWxhYmxlQGdtYWlsLmNvbSJ9fSwicm9vbSI6IioifQ.SRt8dXHsSvOjM0imm1GLYDf0T09KFRnVoFGPeEwU9GUtmv0C4yUoHK4TJnj7hEh327-ngxEo1K70OEbeuoi_xbbvV19sIVc0UyOgFHO1nPfVG1c42nkXTV3Xqib4MFWKCOgFIQbM71IZppdkCAic7GZKGtgIgEbIb7h4e1BuoHh-31NCzhbloBGk5T3YfYs44559LewMRVCTYE2FD3NSWgfTwIkNsi0TjfV77sQrsnNC40SRQ1WxnusMziBloWLsX4t6bz8Cvk9ooowl19GmOEJAxItBa3KkcOTxwSi-Binp2XNkS3J4wtvnnOEryn1JmKumEzlUlq7vJm3yZWTe1A" }
				//jwt = {"eyJraWQiOiJ2cGFhcy1tYWdpYy1jb29raWUtYWJhNzlkZGY4ZTEyNDAyMDg4NzdiMzI0YTg4ZmY0ZDEvNDUzMzYzIiwidHlwIjoiSldUIiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiJ2cGFhcy1tYWdpYy1jb29raWUtYWJhNzlkZGY4ZTEyNDAyMDg4NzdiMzI0YTg4ZmY0ZDEiLCJhdWQiOiJqaXRzaSIsIm5iZiI6MTY5Mjc4NTA5MCwiaXNzIjoiY2hhdCIsImNvbnRleHQiOnsiZmVhdHVyZXMiOnsibGl2ZXN0cmVhbWluZyI6InRydWUiLCJvdXRib3VuZC1jYWxsIjoidHJ1ZSIsInRyYW5zY3JpcHRpb24iOiJ0cnVlIiwicmVjb3JkaW5nIjoidHJ1ZSJ9LCJ1c2VyIjp7Im1vZGVyYXRvciI6InRydWUiLCJuYW1lIjoiU3VtaXQiLCJpZCI6ImQ4NTIwNzA2LTZiZTktNDYwNS1hNmIzLTJhNTIxNzZlMmEwOSIsImF2YXRhciI6Imh0dHBzOi8vYXZhdGFydXJsLmNvbS9hdmF0YXIvdXJsIn19LCJleHAiOjE2OTI3OTIzMDAsInJvb20iOiIqIn0.YHXLKskmvYon9nntG68MPqbWWvNOT-_BIo0Hq52K_uH0USW_VWX0rKgTapyt_yPc3YVNr6q6gRtWfwAfUcN3mkZ-6U0PPC_udLonW17QnL61-rFLpjs1HhgtJTQFrTF79w55DtEd-RZJm1wB49WDMuP2VJN8VVFptYSua85AEcgV7wFc-bPsr6b_zSjaITcFX4SE31m71wMQ0wqqxDjryfr72pi4rdJ7qwa-c6b7zWfbQAiRe4avEAOG6B2fxuAW73GxdYFiP50gHSHkcpm_XExbWLwT40r0DRdsLvUFA_v1iMPp2RiiH2pl5XDVSmgN2Mi7O0XQ2ES9tfmc1G0XKw"}
                roomName = {meetingId}		
				enableWelcomePage={false}	
                userInfo = {{
                    displayName: etlStudentObj.studentName,                    
                }}                
                configOverwrite = {{
                    subject: meetingTitle,
                    ///requireDisplayName: false,
                    hideConferenceSubject: false,
                    disableDeepLinking: true,
                    disableThirdPartyRequests: true,
                    disableLocalVideoFlip: true,
                    backgroundAlpha: 0.5                    
                }}	
                whiteboard = {{
                    enabled: true
                }}
                interfaceConfigOverwrite = {{                    
                    VIDEO_LAYOUT_FIT: 'nocrop',
                    MOBILE_APP_PROMO: false,
                    TILE_VIEW_MAX_COLUMNS: 4
                }}
                // Update this with the `8x8.vc` or `stage.8x8.vc` version of interest
                // and avoid mixing up different domains and release versions
                // on the same page at the same time, as only the first
                // external api script will be loaded.
                // release = 'release-1234'
                onReadyToClose = { handleReadyToClose }
                getIFrameRef = { handleJaaSIFrameRef } />
            {/* {renderButtons()}
            {renderNewInstance()}
            {renderLog()} */}
        </div>
    );
};

export default App;
